(() => {
  const normalize = (value) => String(value || '')
    .toLowerCase()
    .replace(/colours/g, 'colors')
    .replace(/colour/g, 'color')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const initialize = (root) => {
    if (!root || document.documentElement.dataset.colorsLandingInitialized === 'true') return;
    document.documentElement.dataset.colorsLandingInitialized = 'true';

    const panel = root.querySelector('[data-colors-product-panel]');
    const heading = root.querySelector('[data-colors-purchase-heading]');
    const neutralTemplate = root.querySelector('[data-colors-neutral-template]');
    const indexNode = root.querySelector('[data-colors-product-index]');
    const purchase = root.querySelector('.colors-landing__purchase');
    const purchaseSearch = root.querySelector('[data-colors-purchase-search]');
    const purchaseSearchExpanded = root.querySelector('[data-colors-purchase-search-expanded]');
    const purchaseSearchSummary = root.querySelector('[data-colors-purchase-search-summary]');
    const selectedLocation = root.querySelector('[data-colors-selected-location]');
    const changeLocation = root.querySelector('[data-colors-change-location]');
    let products = [];
    let requestController;
    let currentPlace = '';
    const productMarkupCache = new Map();
    const galleryImageCache = new Map();
    const productSectionId = 'template--28383748292925__main';

    try {
      products = JSON.parse(indexNode.textContent || '[]');
    } catch (error) {
      console.error('Colors Of product index could not be read.', error);
    }

    const byPlace = new Map(products.map((product) => [product.place, product]));

    const setPurchaseSearchState = (product, expanded) => {
      if (!purchaseSearch || !purchaseSearchExpanded || !purchaseSearchSummary) return;
      purchaseSearchExpanded.hidden = !expanded;
      purchaseSearchSummary.hidden = expanded || !product;
      purchaseSearchSummary.setAttribute('aria-hidden', String(expanded || !product));
      purchaseSearch.dataset.state = !expanded && product ? 'selected' : 'search';
      if (product && selectedLocation) selectedLocation.textContent = product.label;
    };

    const setSelectedPanelContent = (content) => {
      purchaseSearch.remove();
      panel.innerHTML = '';
      const mount = document.createElement('div');
      mount.className = 'colors-landing__selected-location-mount';
      mount.appendChild(purchaseSearch);
      panel.appendChild(mount);
      if (typeof content === 'string') panel.insertAdjacentHTML('beforeend', content);
      else panel.appendChild(content);
    };

    const closeResults = (search) => {
      const results = search.querySelector('[data-colors-search-results]');
      const input = search.querySelector('[data-colors-search-input]');
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      delete results.dataset.activeIndex;
    };

    const rankedMatches = (term) => {
      const query = normalize(term);
      if (!query) return [];
      return products
        .filter((product) => product.available !== false && normalize(product.label).includes(query))
        .sort((a, b) => {
          const aStarts = normalize(a.label).startsWith(query) ? 0 : 1;
          const bStarts = normalize(b.label).startsWith(query) ? 0 : 1;
          return aStarts - bStarts || a.label.localeCompare(b.label);
        })
        .slice(0, 8);
    };

    const renderResults = (search, term) => {
      const results = search.querySelector('[data-colors-search-results]');
      const input = search.querySelector('[data-colors-search-input]');
      const matches = rankedMatches(term);
      results.innerHTML = '';

      if (!String(term || '').trim()) {
        closeResults(search);
        return matches;
      }

      if (!matches.length) {
        results.innerHTML = '<div class="colors-search__message">We couldn\'t find that location. <a href="/pages/request-a-location">Request it free.</a></div>';
      } else {
        matches.forEach((product) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'colors-search__result';
          button.setAttribute('role', 'option');
          button.dataset.colorsResult = product.place;
          button.addEventListener('pointerenter', () => prefetchProduct(product), { passive: true, once: true });
          button.addEventListener('focus', () => prefetchProduct(product), { once: true });
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            button.appendChild(image);
          }
          const copy = document.createElement('span');
          const label = document.createElement('strong');
          const title = document.createElement('small');
          label.textContent = product.label;
          title.textContent = product.title;
          copy.append(label, title);
          button.appendChild(copy);
          results.appendChild(button);
        });
      }

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      return matches;
    };

    const resetNeutral = () => {
      if (requestController) requestController.abort();
      currentPlace = '';
      panel.removeAttribute('aria-busy');
      purchaseSearch.remove();
      panel.innerHTML = neutralTemplate.innerHTML;
      panel.querySelector('[data-colors-location-mount]')?.appendChild(purchaseSearch);
      heading.textContent = 'Choose a location to preview your print.';
      root.querySelectorAll('[data-colors-search-input]').forEach((input) => { input.value = ''; });
      setPurchaseSearchState(null, true);
    };

    const runReusableInlineScripts = (sourceWrapper, targetWrapper) => {
      const scripts = Array.from(sourceWrapper.querySelectorAll('script:not([src])'));
      scripts.forEach((sourceScript) => {
        const type = sourceScript.getAttribute('type') || '';
        const code = sourceScript.textContent || '';
        if (type && !/javascript|ecmascript/i.test(type)) return;
        if (!code.includes('data-product-pairing') && !code.includes('variant-selects-')) return;
        const script = document.createElement('script');
        script.textContent = code;
        targetWrapper.appendChild(script);
      });
    };

        const normalizeInjectedProductOptions = (wrapper) => {
      const findGroup = (pattern) => Array.from(wrapper.querySelectorAll('fieldset')).find((fieldset) => {
        const legend = fieldset.querySelector('legend');
        return pattern.test((legend?.textContent || fieldset.getAttribute('aria-label') || '').trim());
      });
      const findChoice = (fieldset, pattern) => {
        if (!fieldset) return null;
        return Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => {
          const label = input.id ? fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
          return pattern.test(`${input.value || ''} ${input.getAttribute('aria-label') || ''} ${label?.textContent || ''}`);
        });
      };
      const applyDefaultsAndOrder = () => {
        const sizeGroup = findGroup(/select size|size/i);
        const frameGroup = findGroup(/framing option|frame/i);
        const preferredSize = findChoice(sizeGroup, /18\s*[x×]\s*24/i);
        const printOnly = findChoice(frameGroup, /print only/i);
        const digitalFile = findChoice(frameGroup, /digital file/i);
        if (preferredSize && !preferredSize.checked) preferredSize.click();
        if (printOnly && !printOnly.checked) printOnly.click();
        if (digitalFile) {
          const digitalLabel = digitalFile.id ? frameGroup.querySelector(`label[for="${CSS.escape(digitalFile.id)}"]`) : null;
          frameGroup.appendChild(digitalFile);
          if (digitalLabel) frameGroup.appendChild(digitalLabel);
        }
      };
      applyDefaultsAndOrder();
      [300, 900, 1800].forEach((delay) => window.setTimeout(applyDefaultsAndOrder, delay));
    };

    const sizedImageUrl = (url, width = 990) => {
      if (!url) return '';
      const absolute = new URL(url, window.location.origin);
      absolute.searchParams.set('width', String(width));
      return absolute.toString();
    };

    const preloadProductHero = (product) => {
      const src = sizedImageUrl(product?.image, 990);
      if (!src || galleryImageCache.has(src)) return;
      const image = new Image();
      image.decoding = 'async';
      image.src = src;
      galleryImageCache.set(src, image);
    };

    const fetchProductMarkup = (product) => {
      if (productMarkupCache.has(product.place)) return productMarkupCache.get(product.place);
      const request = (async () => {
        const sectionUrl = new URL(product.url, window.location.origin);
        sectionUrl.searchParams.set('section_id', productSectionId);
        let response = await fetch(sectionUrl, {
          headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        });
        let html = response.ok ? await response.text() : '';
        if (!response.ok || !html.includes('shopify-section-')) {
          response = await fetch(product.url, {
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
          html = await response.text();
        }
        return html;
      })();
      productMarkupCache.set(product.place, request);
      request.catch(() => productMarkupCache.delete(product.place));
      return request;
    };

    const optimizeInjectedGallery = (wrapper) => {
      const galleryNodes = Array.from(wrapper.querySelectorAll('[id^="Slider-Gallery-"] img'));
      const slides = Array.from(new Map(galleryNodes.map((image) => {
        const slide = image.closest('li');
        return [slide?.id || image.currentSrc || image.src, slide || image.parentElement];
      })).values());
      const images = slides.map((slide) => slide.querySelector('img')).filter(Boolean);
      if (!images.length) return;
      images.forEach((image, index) => {
        image.decoding = 'async';
        if (index === 0) {
          image.loading = 'eager';
          image.fetchPriority = 'high';
        } else {
          image.loading = 'lazy';
          image.fetchPriority = 'auto';
        }
      });

      const warmImage = (index) => {
        const source = images[index];
        if (!source) return null;
        const key = source.currentSrc || source.src;
        if (!key) return null;
        if (galleryImageCache.has(key)) return galleryImageCache.get(key);
        const image = new Image();
        image.decoding = 'async';
        if (source.srcset) image.srcset = source.srcset;
        if (source.sizes) image.sizes = source.sizes;
        image.src = source.src;
        galleryImageCache.set(key, image);
        return image;
      };

      const upgradeToHd = (index) => {
        const source = images[index];
        const slide = slides[index];
        if (!source || !slide || slide.dataset.hdUpgradeStarted === 'true') return;
        slide.dataset.hdUpgradeStarted = 'true';
        const hdUrl = new URL(source.src, window.location.origin);
        hdUrl.searchParams.set('width', '1946');
        const hdSrc = hdUrl.toString();
        const cacheKey = `hd:${hdSrc}`;
        let hdImage = galleryImageCache.get(cacheKey);
        if (!hdImage) {
          hdImage = new Image();
          hdImage.decoding = 'async';
          hdImage.src = hdSrc;
          galleryImageCache.set(cacheKey, hdImage);
        }
        const applyHd = () => {
          slide.querySelectorAll('img').forEach((image) => {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = hdSrc;
            image.dataset.hdUpgraded = 'true';
          });
        };
        if (hdImage.complete && hdImage.naturalWidth) applyHd();
        else hdImage.addEventListener('load', applyHd, { once: true });
      };

      const scheduleNextAndHd = () => {
        const run = () => {
          const nextImage = warmImage(1);
          if (navigator.connection?.saveData) return;
          warmImage(2);
          const upgradeFirst = () => window.setTimeout(() => upgradeToHd(0), 150);
          if (nextImage?.complete) upgradeFirst();
          else if (nextImage) nextImage.addEventListener('load', upgradeFirst, { once: true });
          else upgradeFirst();
        };
        if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 700 });
        else window.setTimeout(run, 200);
      };
      if (images[0].complete) scheduleNextAndHd();
      else images[0].addEventListener('load', scheduleNextAndHd, { once: true });

      slides.forEach((slide, index) => {
        slide.addEventListener('touchstart', () => {
          upgradeToHd(index);
          if (!navigator.connection?.saveData) {
            warmImage(index + 1);
            warmImage(index + 2);
          }
        }, { passive: true });
        slide.addEventListener('pointerdown', () => upgradeToHd(index), { passive: true });
      });

      const thumbnails = Array.from(wrapper.querySelectorAll('[id^="Slider-Thumbnails-"] button'));
      thumbnails.forEach((button, index) => {
        const warmAdjacent = () => {
          warmImage(index);
          warmImage(index + 1);
        };
        button.addEventListener('pointerenter', warmAdjacent, { passive: true });
        button.addEventListener('touchstart', () => {
          warmAdjacent();
          upgradeToHd(index);
        }, { passive: true });
        button.addEventListener('click', () => {
          warmAdjacent();
          window.setTimeout(() => upgradeToHd(index), 250);
        });
      });

      const viewer = wrapper.querySelector('[id^="GalleryViewer-"]');
      const desktopQuery = window.matchMedia('(min-width: 750px)');
      if (viewer && thumbnails.length > 1 && !viewer.querySelector('[data-desktop-gallery-nav]')) {
        const makeNavButton = (direction, label) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', label);
          button.dataset.desktopGalleryNav = direction;
          Object.assign(button.style, {
            position: 'absolute',
            top: '0',
            bottom: '0',
            [direction]: '0',
            width: '72px',
            height: '100%',
            transform: 'none',
            padding: '0',
            border: '0',
            background: 'transparent',
            cursor: 'pointer',
            zIndex: '50',
            display: desktopQuery.matches ? 'block' : 'none'
          });
          return button;
        };
        const previous = makeNavButton('left', 'Previous product image');
        const next = makeNavButton('right', 'Next product image');
        const navigate = (change, event) => {
          event.preventDefault();
          event.stopPropagation();
          const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
          const currentIndex = activeIndex >= 0 ? activeIndex : 0;
          const targetIndex = (currentIndex + change + thumbnails.length) % thumbnails.length;
          warmImage(targetIndex);
          warmImage((targetIndex + 1) % thumbnails.length);
          thumbnails[targetIndex]?.click();
        };
        viewer.addEventListener('click', (event) => {
          if (!desktopQuery.matches) return;
          const rect = viewer.getBoundingClientRect();
          const offsetX = event.clientX - rect.left;
          if (offsetX <= 72) navigate(-1, event);
          else if (offsetX >= rect.width - 72) navigate(1, event);
        }, true);
        previous.addEventListener('click', (event) => navigate(-1, event));
        next.addEventListener('click', (event) => navigate(1, event));
        desktopQuery.addEventListener?.('change', (event) => {
          const display = event.matches ? 'block' : 'none';
          previous.style.display = display;
          next.style.display = display;
        });
        if (!document.getElementById('desktop-gallery-arrow-click-through')) {
      const style = document.createElement('style');
      style.id = 'desktop-gallery-arrow-click-through';
      style.textContent = '@media screen and (min-width: 750px) { .media--icon--left, .media--icon--right, .media--icon--left *, .media--icon--right * { pointer-events: none !important; } }';
      document.head.appendChild(style);
    }

    viewer.append(previous, next);
      }
    };

    const prefetchProduct = (product) => {
      if (!product) return;
      preloadProductHero(product);
      fetchProductMarkup(product).catch(() => {});
    };

const loadProduct = async (product, options = {}) => {
      if (!product) return;
      if (requestController) requestController.abort();
      requestController = new AbortController();
      const requestedPlace = product.place;
      currentPlace = requestedPlace;
      root.querySelectorAll('[data-colors-search-input]').forEach((input) => { input.value = product.label; });
      setPurchaseSearchState(product, false);
      panel.setAttribute('aria-busy', 'true');
      heading.textContent = `Loading ${product.label}...`;
      setSelectedPanelContent('<div class="colors-landing__loading">Loading your artwork and options...</div>');

      try {
        preloadProductHero(product);
        const html = await fetchProductMarkup(product);
        if (currentPlace !== requestedPlace) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sourceWrapper = doc.querySelector('[id^="shopify-section-"][id$="__main"]');
        if (!sourceWrapper) throw new Error('Product section was not found.');

        const importedWrapper = document.importNode(sourceWrapper, true);
        importedWrapper.querySelectorAll('script[src], link[rel="stylesheet"]').forEach((node) => node.remove());
        importedWrapper.querySelectorAll('variant-selects, product-info').forEach((node) => {
          node.dataset.updateUrl = 'false';
        });
        setSelectedPanelContent(importedWrapper);
        optimizeInjectedGallery(importedWrapper);
        runReusableInlineScripts(sourceWrapper, importedWrapper);
        importedWrapper.querySelectorAll('product-form').forEach((productForm) => {
          if (!productForm.form && typeof productForm.initForm === 'function') productForm.initForm();
        });
        panel.removeAttribute('aria-busy');
                normalizeInjectedProductOptions(importedWrapper);
heading.textContent = product.title;
        root.querySelectorAll('[data-colors-search-input]').forEach((input) => { input.value = product.label; });

        if (options.history !== false) {
          const url = new URL(window.location.href);
          url.searchParams.set('place', product.place);
          window.history.pushState({ place: product.place }, '', url);
        }
        if (options.scroll !== false) purchase.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Colors Of product could not be loaded.', error);
        panel.removeAttribute('aria-busy');
        heading.textContent = 'Let\'s try another place.';
        setPurchaseSearchState(product, true);
        setSelectedPanelContent('<div class="colors-landing__error">We couldn\'t load that artwork right now.<br><button type="button" data-colors-retry>Try again</button><br><a href="/pages/request-a-location">Can\'t find your place? Request it free.</a></div>');
        panel.querySelector('[data-colors-retry]')?.addEventListener('click', () => loadProduct(product, options));
      }
    };

    const choosePlace = (place, options) => {
      const product = byPlace.get(place);
      if (!product) return false;
      root.querySelectorAll('[data-colors-search]').forEach(closeResults);
      loadProduct(product, options);
      return true;
    };

    root.querySelectorAll('[data-colors-search]').forEach((search) => {
      const input = search.querySelector('[data-colors-search-input]');
      const form = search.querySelector('[data-colors-search-form]');
      const results = search.querySelector('[data-colors-search-results]');
      let timer;

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => renderResults(search, input.value), 100);
      });
      input.addEventListener('focus', () => { if (input.value.trim()) renderResults(search, input.value); });
      input.addEventListener('keydown', (event) => {
        const options = Array.from(results.querySelectorAll('[data-colors-result]'));
        if (!options.length) return;
        let index = Number(results.dataset.activeIndex ?? -1);
        if (event.key === 'ArrowDown') index = Math.min(index + 1, options.length - 1);
        else if (event.key === 'ArrowUp') index = Math.max(index - 1, 0);
        else if (event.key === 'Enter' && index >= 0) {
          event.preventDefault();
          choosePlace(options[index].dataset.colorsResult);
          return;
        } else if (event.key === 'Escape') {
          closeResults(search);
          return;
        } else return;
        event.preventDefault();
        results.dataset.activeIndex = String(index);
        options.forEach((option, optionIndex) => option.setAttribute('aria-selected', optionIndex === index ? 'true' : 'false'));
        options[index].scrollIntoView({ block: 'nearest' });
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const matches = rankedMatches(input.value);
        if (matches.length) loadProduct(matches[0]);
        else renderResults(search, input.value);
      });
      results.addEventListener('click', (event) => {
        const result = event.target.closest('[data-colors-result]');
        if (result) choosePlace(result.dataset.colorsResult);
      });
    });

    root.addEventListener('pointerover', (event) => {
      const chip = event.target.closest('[data-colors-place]');
      if (chip) prefetchProduct(byPlace.get(chip.dataset.colorsPlace));
    }, { passive: true });

    root.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-colors-place]');
      if (chip) choosePlace(chip.dataset.colorsPlace);
      if (!event.target.closest('[data-colors-search]')) root.querySelectorAll('[data-colors-search]').forEach(closeResults);
    });

    changeLocation?.addEventListener('click', () => {
      const product = byPlace.get(currentPlace);
      setPurchaseSearchState(product, true);
      const input = purchaseSearchExpanded.querySelector('[data-colors-search-input]');
      window.requestAnimationFrame(() => {
        if (input) input.value = '';
        input?.focus();
      });
    });

    window.addEventListener('popstate', () => {
      const place = new URL(window.location.href).searchParams.get('place');
      if (place && byPlace.has(place)) loadProduct(byPlace.get(place), { history: false, scroll: false });
      else resetNeutral();
    });

    const initialPlace = new URL(window.location.href).searchParams.get('place');
    if (initialPlace && byPlace.has(initialPlace)) {
      const initialProduct = byPlace.get(initialPlace);
      preloadProductHero(initialProduct);
      loadProduct(initialProduct, { history: false, scroll: false });
    }
    else resetNeutral();
  };

  const initializeAll = () => {
    if (document.querySelector('[data-colors-landing]')) initialize(document.body);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
